import { render, staticRenderFns } from "./ResultResource.vue?vue&type=template&id=f1805b88"
import script from "./ResultResource.vue?vue&type=script&lang=ts"
export * from "./ResultResource.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports